import { FileService } from './file.service';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "./file.service";
export class AdminService {
    constructor(http, fileService) {
        this.http = http;
        this.fileService = fileService;
    }
    exportReferentiel(callback) {
        this.http.get(`${environment.apiUrl}/referentiel/export`).subscribe((res) => {
            this.fileService.download(res.id);
            if (typeof callback === 'function') {
                callback();
            }
        });
    }
    getImportUrl() {
        return `${environment.apiUrl}/referentiel/import`;
    }
    forceDataRefresh(callback) {
        this.http.post(`${environment.managementUrl}/refresh-data`, null).subscribe(() => {
            if (typeof callback === 'function') {
                callback();
            }
        });
    }
}
AdminService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function AdminService_Factory() { return new AdminService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.FileService)); }, token: AdminService, providedIn: "root" });
